const EducLevelEnum = Object.freeze([{
    name: "Generic Entry",
    code: "GENENTRY",
}, {
    name: "Post Basic",
    code: "POSTBASIC",
},
    {
        name: "Post Graduate",
        code: "POSTGRAD",
    },
    {
        name: "NIMEI Program",
        code: "NIMEI",
    }
]);

export default EducLevelEnum;